import { useTranslation } from 'react-i18next';

export function usePlanLimitsTranslations() {
  const { t } = useTranslation();

  return {
    title: t('planLimits.title'),
    subtitle: t('planLimits.subtitle'),
    loading: t('planLimits.loading'),
    error: t('planLimits.error'),
    currentPlan: t('planLimits.currentPlan'),

    planDetails: {
      basic: t('planLimits.planDetails.basic'),
      business: t('planLimits.planDetails.business'),
      enterprise: t('planLimits.planDetails.enterprise'),
    },

    usage: {
      title: t('planLimits.usage.title'),
      of: t('planLimits.usage.of'),
      unlimited: t('planLimits.usage.unlimited'),
      remaining: (count: number) => t('planLimits.usage.remaining', { count }),
      daysUntilLimit: (days: number) => t('planLimits.usage.daysUntilLimit', { days }),
    },

    resources: {
      sku: {
        title: t('planLimits.resources.sku.title'),
        description: t('planLimits.resources.sku.description'),
      },
      storage: {
        title: t('planLimits.resources.storage.title'),
        description: t('planLimits.resources.storage.description'),
        unit: t('planLimits.resources.storage.unit'),
      },
      users: {
        title: t('planLimits.resources.users.title'),
        description: t('planLimits.resources.users.description'),
      },
      connectors: {
        title: t('planLimits.resources.connectors.title'),
        description: t('planLimits.resources.connectors.description'),
      },
    },

    status: {
      healthy: t('planLimits.status.healthy'),
      caution: t('planLimits.status.caution'),
      warning: t('planLimits.status.warning'),
      critical: t('planLimits.status.critical'),
      exceeded: t('planLimits.status.exceeded'),
    },

    warnings: {
      approaching: t('planLimits.warnings.approaching'),
      nearLimit: (resource: string) => t('planLimits.warnings.nearLimit', { resource }),
      exceeded: (resource: string) => t('planLimits.warnings.exceeded', { resource }),
      upgradeRecommended: t('planLimits.warnings.upgradeRecommended'),
    },

    upgrade: {
      title: t('planLimits.upgrade.title'),
      subtitle: t('planLimits.upgrade.subtitle'),
      currentPlan: (plan: string) => t('planLimits.upgrade.currentPlan', { plan }),
      suggestedPlan: (plan: string) => t('planLimits.upgrade.suggestedPlan', { plan }),
      reasons: t('planLimits.upgrade.reasons'),
      benefits: t('planLimits.upgrade.benefits'),
      buttons: {
        upgrade: t('planLimits.upgrade.buttons.upgrade'),
        contactSales: t('planLimits.upgrade.buttons.contactSales'),
        learnMore: t('planLimits.upgrade.buttons.learnMore'),
      },
    },

    limits: {
      basic: {
        sku: t('planLimits.limits.basic.sku'),
        storage: t('planLimits.limits.basic.storage'),
        users: t('planLimits.limits.basic.users'),
        connectors: t('planLimits.limits.basic.connectors'),
      },
      business: {
        sku: t('planLimits.limits.business.sku'),
        storage: t('planLimits.limits.business.storage'),
        users: t('planLimits.limits.business.users'),
        connectors: t('planLimits.limits.business.connectors'),
      },
      enterprise: {
        sku: t('planLimits.limits.enterprise.sku'),
        storage: t('planLimits.limits.enterprise.storage'),
        users: t('planLimits.limits.enterprise.users'),
        connectors: t('planLimits.limits.enterprise.connectors'),
      },
    },

    progressBar: {
      ariaLabel: (resource: string) => t('planLimits.progressBar.ariaLabel', { resource }),
    },

    tooltips: {
      clickForDetails: t('planLimits.tooltips.clickForDetails'),
      upgradeToIncrease: t('planLimits.tooltips.upgradeToIncrease'),
    },
  };
}
